export const BUNDLE_ACTIONS = {
  UPDATE_DATABINDINGS: 'UPDATE_DATABINDINGS',
  UPDATE_QUERIES_DATA: 'UPDATE_QUERIES_DATA',
  ONE_FORM_UPDATE: 'ONE_FORM_UPDATE',
  ADD_DATABINDINGS: 'ADD_DATABINDINGS',
  UPDATE_INDEX_QUERIES_DATA: 'UPDATE_INDEX_QUERIES_DATA', // Index based data update in the store
  CLEAR_QUERIES_DATA: 'CLEAR_INDEX_QUERIES_DATA', // To clear all data when seleceted patient change
  ADD_CONFIG_BINDINGS: 'ADD_CONFIGBINDINGS',
  REMOVE_DATABINDINGS: 'REMOVE_DATABINDINGS',
  REMOVE_CONFIG_BINDINGS: 'REMOVE_CONFIGBINDINGS'
};
